"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Person {
    constructor(_id, _firstName, _lastName, _email) {
        this._id = _id;
        this._firstName = _firstName;
        this._lastName = _lastName;
        this._email = _email;
    }
    static fromObject(object) {
        return new Person(object.id, object.firstName, object.lastName, object.email);
    }
    get id() { return this._id; }
    get firstName() { return this._firstName; }
    get lastName() { return this._lastName; }
    get email() { return this._email; }
    isLoggedIn() {
        return this.id > 2;
    }
}
exports.Person = Person;
//# sourceMappingURL=value objects.js.map


// WEBPACK FOOTER //
// ./build/contacts/value objects.js